export const MOBILE_WEB_HOSTNAME = 'm.wavve.com'
export const PC_WEB_HOSTNAME = 'www.wavve.com'
export const SPECIAL_PROMOTION_HOSTNAME = 'pp.wavve.com'
export const IS_SPECIAL_PROMOTION_PAGE = location.hostname === SPECIAL_PROMOTION_HOSTNAME
export const PROMOTION_MAPPER = {
  [SPECIAL_PROMOTION_HOSTNAME]: 'forholder'
}
export const API_BASE_URL = 'https://apis.wavve.com'
export const API_BASE_URL_CLOVER_FIELD = 'https://apis.wavve.com/cf'
export const API_BASE_URL_FROZEN = 'https://apis.wavve.com/fz'
// export const API_BASE_AZURE_URL = 'https://apis.wavve.com'
export const URL_COOKIE_DOMAIN = location.hostname.replace('m.', '').replace('pp.', '')
export const URL_PROTOCOL_DOMAIN = location.protocol + '//' + location.hostname
export const IMG_WAVVW_COM = 'img.wavve.com'
export const IMAGE_WAVVE_COM = 'image.wavve.com'
export const IMAGE_CDN_WAVVE_COM = 'image.cdn.wavve.com'
export const IMG_POOQ_CO_KR = 'img.pooq.co.kr'
export const DEV_IMG_CDN_WAVVE_COM = 'dev-image.cdn.wavve.com'
export const QA_IMG_CDN_WAVVE_COM = 'qa-image.cdn.wavve.com'
export const URL_WAVVE_DEV = 'm-dev.wavve.com'
export const URL_WAVVE_QA = 'm-qa.wavve.com'
export const URL_WAVVE_STG = 'm-stg.wavve.com'

export const DOCUMENT_DOMAIN = location.hostname.replace('m.', '')
export const API_KEY = 'E5F3E0D30947AA5440556471321BB6D9'

export const IS_PRODUCTION_MODE = process.env.NODE_ENV === 'production'

export const COOKIE_KEY_USER_ID = 'userId'
export const COOKIE_KEY_USER_INFO = 'cs'
export const COOKIE_KEY_AUTO_LOGIN_CREDENTIAL = 'credential'
export const COOKIE_KEY_CREDENTIAL = 'credential'
export const COOKIE_KEY_VERIFIED_ADULT = 'verifiedAdult'
export const COOKIE_KEY_APP_CREDENTIAL = 'app-credential'
export const COOKIE_KEY_APP_POOQZONE = 'app-pooqzone'
export const COOKIE_KEY_APP_DRM = 'app-drm'
export const COOKIE_KEY_APP_DEVICE = 'app-device'

export const CREDENTIAL_NONE = 'none'

export const ADULT_SETTINGS_KEY = 'adult-settings'

export const LOCAL_STORAGE_PREV_SEARCH_KEY = 'pooq:prev-search-key-word-list'
export const SESSION_STORAGE_NOTICE_POPUP_VIEW_KEY = 'pooq:notice-popup-view'

// encode 하면 안됨
// for test only
// export const CREDENTINAL = 'XRIextSiEr2lGvdexpQ88Xx0AzZMIiav%2BnGY6Wr0qbmuW9jIY%2ByGpQBWoexLBkFcn4uwKWovLFqtaz1%2FtczJxZqpaDHLUasE3cRhni7l8u11b2DsVhnVZf6qytMDOdAmoiIiqNE8XnGeFw8NrVKngpImHkNy776RACBLvP2oELvRjsgUVvo%2BJ%2FsnpqU8Tmnze6c45lKS4DsUDSxTcpEB79FfR0AyeYwXJzj3As7FxIIsLxxuIVtCynLk%2F%2FNLWYz5'

export const CELL_TYPE_THUMBNAIL = 'thum'
export const CELL_TYPE_POSTER = 'poster'
export const CELL_TYPE_CIRCLE = 'circle'
export const CELL_TYPE_LAUNCHER = 'launcher'
export const CELL_TYPE_AUTOPLAY = 'autoplay'

export const URL_GET_RECOMMENDATION = API_BASE_URL_CLOVER_FIELD + '/recommendation'
export const URL_GET_ALL_PROGRAMS = API_BASE_URL_CLOVER_FIELD + '/allprograms'
export const URL_GET_CONTENT_DETAIL = API_BASE_URL_CLOVER_FIELD + '/contents'
// export const URL_GET_RECOMMENDATION_VOD = API_BASE_URL + '/recommendation' // VOD 콘텐츠 상세화면 추천용 멀티 콘텐츠 목록
// export const URL_GET_RECOMMENDATION_MOVIE = API_BASE_URL + '/recommendation/movie' // 영화 콘텐츠 상세화면 추천용 멀티 콘텐츠 목록

export const SORT_BY_OLDER = 'old'
export const SORT_BY_NEWER = 'new'

export const CATEGORY_BROAD_CAST = 'vodgenre'
export const CATEGORY_MOVIE = 'moviegenre'
export const CATEGORY_MOVIE_SVOD = 'moviegenre_svod'
export const CATEGORY_MOVIE_PLUS = 'moviegenre_ppv'
export const TAGS_BROAD_CAST = 'vodsearch_dark'
export const TAGS_MOVIE = 'moviesearch'

export const MAX_SELECT_COUNT = 30

export const NOT_A_ADULT_CONTENT = 'not_a_adult_content'
export const ALREADY_ADULT_VERIFIED = 'alreadyAdultVerified'
export const NEED_LOGIN = 'needLogin'
export const NEED_PIN_CODE = 'need_pin_code'
export const HIDDEN_CONTENT_REDIRECT_TO_HOME = 'hidden_content_redirect_to_home'
export const NEED_VERIFIED = 'needVerified'

export const PROGRAM = 'program'
export const VOD = 'vod'
export const LIVE = 'live'
export const PLAYER = 'player'
export const TV_CUT = 'tvcut'
export const EDITOR_PICK = 'theme'

// --------------------------------------------------------------------------
// Message
// --------------------------------------------------------------------------
export const MSG_NEED_FOR_MOVING_LOGIN = '로그인 후 이용하실 수 있습니다.\n로그인 페이지로 이동하시겠습니까?'
export const MSG_VOUCHER_SNS_ALERT = '해당 SNS ID로 이용권 구매 후 SNS를 탈퇴하시면 Wavve 서비스를 이용하실 수 없습니다. 이점 꼭 유의하세요.'
export const MSG_MOVING_MYPOOQ_COIN = '쿠폰 등록이 완료되었습니다.\n코인함으로\n이동하시겠습니까?'
export const MSG_MOVING_MYPOOQ_COUPON = '쿠폰 등록이 완료되었습니다.\n보관함으로\n이동하시겠습니까?'
export const MSG_MYPOOQ_COUPON_NO_VALUE = '쿠폰번호를 입력해 주세요.'
export const MSG_MYPOOQ_COUPON_COMPLETE = '쿠폰 등록이 완료되었습니다.'
export const MSG_MYPOOQ_CONFIRM_COIN_UNSUBSCRIBE = '코인 자동결제를 해지\n하시겠어요?'
export const MSG_MYPOOQ_CONFIRM_COIN_REVOKE_SUBSCRIBE = '코인 자동결제를 해지를\n 취소 하시겠어요?'
export const MSG_MYPOOQ_CONFIRM_CANCEL_EDIT = '취소시 내용이 저장되지 않습니다.\n취소하시겠어요?'
export const MSG_MYPOOQ_ALERT_MAX_EDIT = '최대 30개 까지만 선택할수 있습니다.'
export const MSG_MYPOOQ_COMPLETE_UNSUBSCRIBE = '자동결제가 해지되었습니다.\n자동결제를 다시 유지하고 싶으신 경우\n익일부터 이용권 만료일 하루 전까지\n[자동결제 해지 취소]가 가능합니다.'
export const MSG_MYPOOQ_ASK_CANCEL_UNSUBSCRIBE = '자동결제 해지를 취소하겠습니까? 취소 시 원 자동결제 예정일인 YYYY-MM-DD에 자동결제가 재개됩니다.'
export const MSG_MYPOOQ_CANCEL_COMPLETE_UNSUBSCRIBE = '자동결제가 해지가 취소되었습니다.'
export const MSG_ASK_ADD_LIVE_ALARM = '시청예약 하시겠습니까? \n시청예약 알림은 모바일앱 PUSH 알림으로 전송됩니다. 모바일 앱 설치 및 PUSH 알림 동의 여부를 꼭 확인해주세요!'
export const MSG_COMPLETE_ADD_UPLOAD_ALARM = '업로드 알림이 등록되었어요.'
export const MSG_COMPLETE_DELETE_UPLOAD_ALARM = '업로드 알림 등록이 해제되었어요.'
export const MSG_COMPLETE_ADD_MOVIE_ALARM = '알림이 등록되었어요.'
export const MSG_COMPLETE_DELETE_MOVIE_ALARM = '알림 등록이 해제되었어요.'
export const MSG_COMPLETE_ADD_LIVE_ALARM = '시청 예약이 설정되었어요.'
export const MSG_ASK_DELETE_ALARM_LIVE = '시청 예약을 취소하시겠어요?'
export const MSG_COMPLETE_DELETE_LIVE_ALARM = '시청 예약이 취소 되었어요.'
export const MSG_COMPLETE_ADD_ZZIM_PROGRAM = '관심 프로그램으로 등록했어요.\n새로운 에피소드 업로드시 알려드릴게요.'
export const MSG_COMPLETE_ADD_ZZIM_PROGRAM_ERROR = '죄송합니다.\n 해당 콘텐츠는 구독 기능을 지원하지 않습니다.'
export const MSG_COMPLETE_ADD_ZZIM_LIVE = '관심 채널로 등록했어요.'
export const MSG_COMPLETE_ADD_ZZIM_EDITOR_PICK = '관심 에디터Pick으로 등록했어요.'
export const MSG_COMPLETE_ADD_ZZIM_MOVIE = '관심 영화로 등록했어요.'
export const MSG_ASK_DELETE_ZZIM_PROGRAM = '프로그램 ‘좋아요’ 를 취소하시겠어요? 좋아요 취소 시 신규 회차 업로드 알림도 해제됩니다.'
export const MSG_ASK_DELETE_ZZIM_LIVE = '관심 프로그램 등록을 취소하시겠어요?'
export const MSG_ASK_DELETE_ZZIM_MOVIE = '좋아요를 취소하시겠어요?'
export const MSG_COMPLETE_DELETE_ZZIM_PROGRAM = '관심 프로그램 등록을 취소했어요.'
export const MSG_COMPLETE_DELETE_ZZIM_LIVE = '관심 채널 등록을 취소했어요.'
export const MSG_COMPLETE_DELETE_ZZIM_MOVIE = '관심 영화 등록을 취소했어요.'
export const MSG_COMPLETE_DELETE_ZZIM_EDITOR_PICK = '관심 에디터Pick 등록을 취소했어요.'
export const MSG_POOQZONE_PINCODE_EMPTY = '웨이브온 접속번호를 입력해 주세요.'
export const MSG_ASK_DELETE_USER_QNA = '선택하신 문의 내역을 삭제하시겠습니까?'
export const MSG_CRM_COMPLETE_REVOCATION = '자동결제가 해지되었습니다. 자동결제를 다시 유지하고 싶으신 경우 익일부터 이용권 만료일 하루 전까지 [해지 신청 취소]가 가능합니다.'
export const MSG_ASK_DELETE_ALL_ALARMS = '알림을 모두 삭제 하시겠습니까?'
export const MSG_ASK_DELETE_ALL_PREV_SEARCH_KEYWORD = '최근 검색어를 모두 삭제하시겠습니까?'
export const MSG_INFO_ONLY_SUBSCRIBE_APP_PAGE = 'APP으로 구독하신 경우에만 제공되는 페이지입니다.'
export const MSG_INFO_IOS_SUBSCRIPTION_CANCEL = 'IOS 앱 내 구매 이용권은 IOS 페이지에서만 해지 취소가 가능합니다.'
export const MSG_INFO_ONLY_IOS_USED = 'IOS 앱 내 구매 이용권은 IOS 페이지에서만 변경 가능합니다'
export const MSG_INFO_ONLY_GOOGLE_USED = 'Google 앱 내 구매 이용권은 Google Play 페이지에서만 변경 가능합니다.'
export const MSG_CONFIRM_SELECT_DELETE_UNLIMITED_PERIOD = '영구소장 콘텐츠가 포함되어 있습니다. \n삭제하시겠습니까?'
export const MSG_CONFIRM_ALL_DELETE_UNLIMITED_PERIOD = '영구소장 콘텐츠가 포함되어 있습니다. \n전체 내역을 삭제하시겠습니까?'
export const MSG_CONFIRM_SELECT_DELETE_SALES_EXPIRED = '삭제 시 시청이 불가능한 \n판매 종료된 콘텐츠가 포함되어 있습니다.\n삭제하시겠습니까?'
export const MSG_CONFIRM_ALL_DELETE_SALES_EXPIRED = '삭제 시 시청이 불가능한 \n판매 종료된 콘텐츠가 포함되어 있습니다.\n전체 내역을 삭제하시겠습니까?'

export const META_INFO_DEFAULT_TITLE = 'Wavve(웨이브)'
export const META_INFO_DEFAULT_OG_TITLE = 'Wavve(웨이브)'
export const META_INFO_DEFAULT_DESCRIPTION = '세상 얕은 콘텐츠부터 세상 딥한 콘텐츠까지 JUST DIVE! Wavve'
export const META_INFO_DEFAULT_OG_DESCRIPTION = '세상 얕은 콘텐츠부터 세상 딥한 콘텐츠까지 JUST DIVE! Wavve'
export const META_INFO_DEFAULT_OG_IMAGE = 'http://img.wavve.com/service30/profile/pooq.png'
export const META_INFO_DEFAULT_OG_SECURE_IMAGE = 'https://img.wavve.com/service30/profile/pooq.png'
export const META_INFO_DEFAULT_OG_URL = 'https://m.wavve.com'

export const SERVICE_LOCATION_KEY = 'service_location_key'
export const SERVICE_LOCATION_AMAZON = 'aws'
export const SERVICE_LOCATION_AZURE = 'azure'

export const SERVICE_LOCATION_QUERY_VALUE_AZURE = 'az'

export const PAYMENT_GATE_TYPE_ONE_STORE = 'onestore'
export const PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE = 'google'
export const PRODUCT_TYPE_SUBSCRIPTION = 'subscription'
export const PRODUCT_TYPE_PRODUCT = 'product'

export const SNS_FACEBOOK = 'facebook'
export const SNS_KAKAO = 'kakao'
export const SNS_NAVER = 'naver'
export const SNS_TID = 'tid'
export const SNS_APPLE = 'apple'

export const SNS_TYPE_LIST = [
  SNS_FACEBOOK, SNS_KAKAO, SNS_NAVER, SNS_TID, SNS_APPLE
]

export const MY_EMPTY_MESSAGE_LIST = [
  { title: '전체 시청내역', message: '시청내역이 없어요' },
  { title: '관심 프로그램', message: '관심 프로그램이 없어요' },
  { title: '관심 영화', message: '관심 영화가 없어요' },
  { title: '관심 에디터Pick', message: '관심 에디터Pick이 없어요' }
]

const HTTP_METHOD_GET = 'get'
const HTTP_METHOD_POST = 'post'
const HTTP_METHOD_DELETE = 'delete'
export const AWS_WHITE_LIST = [
  // login
  { path: '/login', method: HTTP_METHOD_POST },
  { path: '/logout', method: HTTP_METHOD_POST },

  // profiles
  { path: '/profiles', method: HTTP_METHOD_GET },
  { path: '/profiles-images', method: HTTP_METHOD_GET },
  { path: '/profiles/{path}', method: HTTP_METHOD_GET },
  { path: '/profiles/{path}', method: HTTP_METHOD_POST },
  // user
  { path: '/user', method: HTTP_METHOD_GET },
  { path: '/user/pin/adult', method: HTTP_METHOD_GET },
  { path: '/user/pin/adult/confirm', method: HTTP_METHOD_POST },
  { path: '/user/pin/adult/ott', method: HTTP_METHOD_POST },
  { path: '/user/purchase/cancel', method: HTTP_METHOD_POST },
  { path: '/user/push', method: HTTP_METHOD_GET },
  { path: '/user/push', method: HTTP_METHOD_POST },
  { path: '/user/qna', method: HTTP_METHOD_GET },
  { path: '/user/qna', method: HTTP_METHOD_DELETE },
  { path: '/user/qna/{path}', method: HTTP_METHOD_GET },
  { path: '/user/tid/auth', method: HTTP_METHOD_GET },
  // pooqzone
  { path: '/pooqzone', method: HTTP_METHOD_GET },
  { path: '/pooqzone/adultcertification', method: HTTP_METHOD_GET },
  { path: '/pooqzone/connectionstatus', method: HTTP_METHOD_GET },
  { path: '/pooqzone/login', method: HTTP_METHOD_POST },
  // 기존
  { path: '/my/summary', method: HTTP_METHOD_GET },
  { path: '/mypurchase/pass/event', method: HTTP_METHOD_POST },
  { path: '/mypurchase/pass/cancel', method: HTTP_METHOD_GET },
  { path: '/mypurchase/pass/cancel', method: HTTP_METHOD_POST },
  { path: '/mypurchase/pass/promotion', method: HTTP_METHOD_GET },
  { path: '/mypurchase/products', method: HTTP_METHOD_GET },
  { path: '/mypurchase/pass/promotion/continue', method: HTTP_METHOD_GET },
  { path: '/mycoupons/register/{path}', method: HTTP_METHOD_POST },
  { path: '/mycoin/summary', method: HTTP_METHOD_GET },
  { path: '/mycoupons/list', method: HTTP_METHOD_GET },
  { path: '/mycoin/list/charged', method: HTTP_METHOD_GET },
  { path: '/mycoupons/activate/{path}', method: HTTP_METHOD_POST },
  { path: '/mycoin/list/expired', method: HTTP_METHOD_GET },

  // smart tv
  { path: '/shorturl/{path}', method: HTTP_METHOD_GET }
]
const today = new Date()
export const CONFIRM_EMERGENCY = '' + today.getFullYear() + (today.getMonth() + 1) + today.getDate()

export const SET_EDITOR_VIEW_CLASS = 'setEditorViewClass'

export const CHANGE_FILTER = 'changeFilter'

export const THUMBNAIL = {
  LANDSCAPE: {
    type: CELL_TYPE_THUMBNAIL,
    width: 320,
    height: 180,
    typeNumber: 2,
    componentName: 'LandscapeCell',
    loadingImageUrl: '/img/common/img_default_thum_2.png'
  },
  PORTRAIT: {
    type: CELL_TYPE_POSTER,
    typeNumber: 1,
    width: 104,
    height: 156,
    componentName: 'PortraitCell',
    loadingImageUrl: '/img/common/img_default_thum_1.png'
  },
  CIRCLE: {
    type: CELL_TYPE_CIRCLE,
    typeNumber: 3,
    width: 160,
    height: 90,
    componentName: 'CircleCell',
    loadingImageUrl: '/img/common/img_default_thum_3.png'
  },
  LAUNCHER: {
    width: 36 * 3,
    height: 36 * 3,
    componentName: 'error',
    placeholderImage: '',
    typeNumber: 4
  }
}

// --------------------------------------------------------------------------
// Braze
// --------------------------------------------------------------------------
export const BRAZE_EVENT_PURCHASE = 'Purchase'
export const BRAZE_DEV_API_KEY = '8b9cc6bf-00bc-47d5-8ed7-70dad8e04d07'
export const BRAZE_PRD_API_KEY = '63c100d0-0534-4a87-8ef7-6f6081373070'
export const BRAZE_QA_API_KEY = 'e2fa8da9-32c0-4cd4-a2e4-14acc9afaa81'
